import { Capacitor } from '@capacitor/core';

export async function readCurrentCoordinates(): Promise<{ lat: number; lng: number }> {
  if (Capacitor.isNativePlatform()) {
    const { Geolocation } = await import('@capacitor/geolocation');
    const permission = await Geolocation.requestPermissions();
    if (permission.location !== 'granted') {
      throw new Error('Location permission was not granted. You can drop a pin or type the address instead.');
    }
    const position = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 12000,
    });
    return { lat: position.coords.latitude, lng: position.coords.longitude };
  }

  if (!navigator.geolocation) {
    throw new Error('This device cannot share its location.');
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
      () =>
        reject(
          new Error('Could not read your current location. Drop a pin or type the address instead.')
        ),
      { enableHighAccuracy: true, timeout: 12000 }
    );
  });
}
